// Global legal disclaimers — shown in all skins.
import { Link } from "react-router-dom";

export default function Disclaimer() {
  return (
    <footer className="border-t border-[var(--border-subtle)] bg-[var(--bg-base)] px-4 py-8 lg:px-14" data-testid="legal-disclaimer">
      <nav className="mb-4 flex items-center justify-center gap-5 text-xs font-medium text-[var(--text-secondary)]" data-testid="footer-nav">
        <Link to="/faq" className="hover:text-[var(--text-primary)]" data-testid="footer-faq-link">FAQ</Link>
      </nav>
      <div className="mx-auto max-w-4xl space-y-2 text-center text-[11px] leading-relaxed text-[var(--text-muted)]">
        <p data-testid="disclaimer-trademarks">
          All streaming service names and logos are trademarks of their respective owners. The Dial is not affiliated with or endorsed by any streaming service.
        </p>
        <p data-testid="disclaimer-tmdb">
          This product uses the TMDB API but is not endorsed or certified by TMDB.
        </p>
      </div>
    </footer>
  );
}
